import React from 'react';

function TopNav() {
    let break_point=window.innerWidth>700
    return (
        <>
            <div className="py-1 d-flex justify-content-evenly " style={{ background: "#050E21" }}>
                <div className="socials">
                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-facebook"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS" style={{ fontSize: "21px" }}><i class="lni lni-twitter"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-instagram-original"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-youtube"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-linkedin"></i></a>

                </div>

                <div className="contact">

                    <a href="tel:+91 75820557151" class="mx-2 white-text text-decoration-none"> <i  class="lni lni-whatsapp" style={{color:"#38BD4B"}}></i> {break_point && "+91 75820557151"} </a>

                    <a href="mailto:support@dotsforall.com" class="mx-2 white-text text-decoration-none "> <i class="lni lni-envelope" style={{color:"#CCAA13"}}></i> {break_point && "support@dotsforall.com"}</a>

                    <a href="" className="btn  btn-sm btn-deep-orange white-text   px-2 " style={{borderRadius:"20px",fontSize:"10px",letterSpacing:"2px",color:"whitesmoke"}}>Interview</a>

                </div>
            </div>
        </>
    )
}

export default TopNav;
